export default __webpack_public_path__ + "files/alert_info.png";